const cache = {
  data: new Map(),
  timeout: new Map(),

  get(key) {
    return this.data.get(key)
  },

  set(key, value, ttl = 60000) {
    this.data.set(key, value)

    if (this.timeout.has(key)) {
      clearTimeout(this.timeout.get(key))
    }

    const timeoutId = setTimeout(() => {
      this.data.delete(key)
      this.timeout.delete(key)
    }, ttl)

    this.timeout.set(key, timeoutId)
  },

  invalidate(key) {
    this.data.delete(key)
    if (this.timeout.has(key)) {
      clearTimeout(this.timeout.get(key))
      this.timeout.delete(key)
    }
  },

  clear() {
    this.data.clear()
    this.timeout.forEach((id) => clearTimeout(id))
    this.timeout.clear()
  },
}

export default cache
